module.exports = __webpack_public_path__ + "static/demis-hassabis-f47854d61f6c9e95a7bf9b25538099c5.jpg";